module.exports = __webpack_public_path__ + "img/93721d5.svg";